<template>
  <div class="container mescroll-touch">
    <div class="navigationBar">
      <div class="nav-left">
        <img @click="goback" src="@/assets/images/back_icon.png" />
      </div>
      <div class="nav-title">
        <span>{{ AlbumName }}</span>
      </div>
      <div class="nav-right" @click="generatePoster">
        <img src="@/assets/images/share_icon1.png" />
      </div>
    </div>
    <div class="details" id="toTop">
      <mescroll-vue ref="mescroll" :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
      <div class="albumInfoBg" v-if="AlbumCover" :style="{ background: `url(${AlbumCover}) center / cover no-repeat` }"></div>
      <div class="albumInfo">
        <img class="albumCover" v-if="AlbumCover" :src="AlbumCover" />
        <div class="albumTitle van-multi-ellipsis--l2">{{ AlbumName }}</div>
        <div class="albumCount" v-if="AlbumDetailsLoad"><template v-if="SubAlbumCount > 0">{{ SubAlbumCount }} 个子专辑<span class="dot">&nbsp;·&nbsp;</span></template>{{ ArtCount }} 个视频<span class="dot">&nbsp;·&nbsp;</span>{{ WatchCount }} 次观看</div>
      </div>
      <div class="list" :class="{'line': PId == 0 && SubAlbumCount > 0}">
        <template v-if="AlbumDetailsLoad && PId == 0 && SubAlbumCount > 0">
          <div class="listItem" v-for="(item, index) in list" :key="index" @click="toAlbumDetails(item.Id)">
            <div class="listCover">
              <img class="cover" :src="item.Url" />
              <img class="cornerMark" src="@/assets/images/album_cornerMark.png" />
            </div>
            <div class="listInfo">
              <div class="title van-multi-ellipsis--l2">{{ item.Name }}</div>
              <div class="count">{{ item.ArtCount }} 个视频<span class="dot">&nbsp;·&nbsp;</span>{{ item.WatchCount.toLocaleString('en-US') }} 次观看</div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="listItem1" v-for="(item, index) in list" :key="index" @click="toArticleDetails(item.Id, item.Type)">
            <div class="listCover">
              <img class="cover" :src="item.Thumbnail" />
            </div>
            <div class="listInfo">
              <div class="title van-multi-ellipsis--l2" :class="{'topTitle': item.IsTop}">{{ item.Title }}</div>
              <div class="count">
                <div class="countItem">
                  <img class="icon" src="@/assets/images/album_eye.png" />
                  <span>{{ item.WatchCount }}</span>
                </div>
                <div class="countItem">
                  <img class="icon" src="@/assets/images/album_like.png" />
                  <span>{{ item.LikeCount }}</span>
                </div>
                <div class="countItem">
                  <img class="icon" src="@/assets/images/album_star.png" />
                  <span>{{ item.CollectCount }}</span>
                </div>
              </div>
            </div>
            <img class="top_icon" v-if="item.IsTop" src="@/assets/images/top_icon.png" />
          </div>
        </template>
      </div>
      </mescroll-vue>
    </div>
    <van-popup class="PosterPopup" v-model="PosterShow" :close-on-click-overlay="false" @opened="generateImageOpened">
        <div class="close" @click="PosterShow = false">
          <van-icon class="closeIcon" name="cross" />
        </div>
        <div class="PosterBox">
          <div class="generateImageBox" ref="generateImageBox" v-if="!PosterPhoto">
            <img class="PosterImg" v-if="AlbumCover" :src="AlbumCover" />
            <div class="QrcodeBox">
              <img class="QrcodeFont" src="@/assets/images/font1.png" />
              <img class="Qrcode" crossOrigin="anonymous" v-if="QRCode" :src="QRCode" />
              <img class="QrcodeFont" src="@/assets/images/font2.png" />
            </div>
          </div>
          <img class="PosterPhoto" v-else :src="PosterPhoto" alt="">
          <p class="tips">请长按保存图片到手机后转发</p>
        </div>
    </van-popup>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import mixin from '../../common/mixin/mixins'
import MescrollVue from 'mescroll.js/mescroll.vue'
import html2canvas from 'html2canvas';
export default {
  name: 'AlbumDetails',
  data() {
    return {
      hasPath: '',
      AlbumDetailsLoad: false,
      PId: 0,
      customerId: 0,
      QRCode: '',
      AlbumName: '',
      AlbumCover: '',
      SubAlbumCount: 0,
      ArtCount: 0,
      WatchCount: 0,
      list: [],
      PageIndex: 0,
      PageSize: 6,
      Total: 0,
      mescroll: null, // mescroll实例对象
      mescrollDown:{
        use: false,
        isLock: false
      },
      mescrollUp: { // 上拉加载的配置.
        isBounce: false,
			  callback: this.upCallback, // 上拉回调
				page: {
					num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
					size: 8 //每页数据条数,默认10
				},
        noMoreSize: 0,
				htmlNodata: '',
        toTop: {
          warpId : 'toTop',
          src: './static/image/top_icon.png' // 回到顶部按钮的图片路径,支持网络图
        },
        // empty: {
        //   // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
        //   warpId: 'dataList', // 父布局的id;
        //   icon: './static/image/none_comm_png@2x.png', // 图标,支持网络图
        //   tip: '敬请期待', // 提示
        // },
			},
      PosterShow: false,
      PosterPhoto: '',
      scrollTop: 0, // 记录离开页面时的滚动位置，用于返回时恢复
    }
  },
  mixins: [mixin],
  components: {
    MescrollVue
  },
  computed: {
    id() {
      return this.$route.query.id
    },
    sourceType() {
      return this.$route.query.sourceType
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if(from.path == '/') {
        vm.hasPath = from.path;
      }
    });
  },
  created() {
    this.getAlbumDetails();
  },
  activated() {
    if(this.scrollTop > 0 && this.$refs.mescroll) {
      this.$refs.mescroll.$el.scrollTop = this.scrollTop;
    }
  },
  methods: {
    getAlbumDetails() {
      this.$axios.post('/Api/Api/Web/Album/GetAlbCount', {
        AlbId: this.id
      }).then(res => {
        let data = res.Data;
        this.PId = data.PId;
        this.QRCode = data.QrCode ? data.QrCode : '';
        this.customerId = data.CusId;
        this.AlbumName = data.Name;
        this.AlbumCover = data.Url;
        this.SubAlbumCount = data.SubAlbumCount;
        this.ArtCount = data.ArtCount;
        this.WatchCount = data.WatchCount.toLocaleString('en-US');
        this.AlbumDetailsLoad = true;
        this.list = [];
        this.mescroll.resetUpScroll();

        wx.miniProgram.postMessage({
          data: {
            share: {
              title: this.AlbumName,
              imageUrl: '',
              path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + `/albumDetails?id=${this.id}&sourceType=7`)}`,
              contentId: ''
            }
          }
        })

        this.BuriedPoint(6, this.AlbumName, '', `/albumDetails?id=${this.id}`, this.id, '', this.$route.query.sourceType ? this.$route.query.sourceType : '');
      })
    },
    mescrollInit (mescroll) {
      if(this.mescroll) {
        this.mescroll.destroy();
      }
			this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
      this.$refs.mescroll.$el.addEventListener('scroll', () => {
        this.scrollTop = this.$refs.mescroll.$el.scrollTop
      })
		},
    // 上拉回调
		upCallback (page) {
      if(this.AlbumDetailsLoad) {
        this.getList(page.num, page.size);
      }
		},
    getList(PageIndex, PageSize) {
      this.PageIndex = PageIndex;
      this.PageSize = PageSize;
      let url = this.PId == 0 && this.SubAlbumCount > 0 ? '/Api/Api/Web/Album/GetAlbChildrenList' : '/Api/Api/Web/Album/GetAlbArtList';
      setTimeout(() => {
        this.$axios.post(url, {
          AlbId: this.id,
          PageIndex: this.PageIndex,
          PageSize: this.PageSize
        }).then(res => {
          let arr = res.Data.List;
          // 如果是第一页需手动置空列表
          if (PageIndex === 1) this.list = []
          // 把请求到的数据添加到列表
          this.list = this.list.concat(arr)
          this.$forceUpdate()
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            this.mescroll.endSuccess(arr.length)
          })
        })
      }, 200);
    },
    generatePoster() {
      this.imageUrls = this.cover;
      this.PosterShow = true;

      this.BuriedPoint(7, this.AlbumName, '', `/albumDetails?id=${this.id}`, this.id, '', this.$route.query.sourceType ? this.$route.query.sourceType : '');
    },
    generateImageOpened() {
      let toast = this.$toast.loading({
        message: '生成中...',
        forbidClick: true,
      });
      
      // 等待所有图片加载完成
      this.$nextTick(async () => {
        const images = this.$refs.generateImageBox.querySelectorAll('img');
        const imagePromises = Array.from(images).map(img => {
          return new Promise((resolve) => {
            if (img.complete && img.naturalHeight !== 0) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = resolve; // 即使出错也继续
            }
          });
        });
        
        try {
          // 等待所有图片加载（或出错）
          await Promise.all(imagePromises);
          
          // 给一个延迟确保 DOM 稳定
          await new Promise(resolve => setTimeout(resolve, 500));
          
          html2canvas(this.$refs.generateImageBox, {
            useCORS: true,
            allowTaint: true, // 允许 tainted canvas
            backgroundColor: null, // 透明背景
            scale: 2, // 提高清晰度
          }).then((canvas) => {
            this.PosterPhoto = canvas.toDataURL("image/png");
            toast.clear();
          }).catch(error => {
            console.error('html2canvas 错误:', error);
            toast.clear();
            this.$toast('生成海报失败，请重试');
          });
          
        } catch (error) {
          toast.clear();
          console.error('图片等待错误:', error);
        }
      });
    },
    toAlbumDetails(id) {
      this.$router.push({
        path: 'albumDetails',
        query: {
          id: id
        }
      });
    },
    toArticleDetails(id, type) {
      if(type == 1 || type == 2) {
        this.$router.push({
          path: 'contentPage',
          query: {
            id: id,
            type: type,
            sourceType: 18,
            sourceId: id
          }
        });
      } else if(type == 3) {
        this.$router.push({
          path: 'liveDetails',
          query: {
            id: id,
            sourceType: 18,
            sourceId: id
          }
        });
      } else if(type == 4) {
        this.$router.push({
          path: 'activityDetails',
          query: {
            id: id,
            sourceType: 18,
            sourceId: id
          }
        });
      }
    },
    goback() {
      if(this.hasPath == '/' ) {
        this.$router.push({
          path: 'Personal',
          query: {
            id: this.customerId
          }
        });
        return;
      }
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #F9F8F7;
}
.navigationBar {
  display: flex;
  align-items: center;
  height: 52px;
  box-sizing: border-box;
  background-color: #EB1700;
  color: #FFFFFF;
  padding: 0 15px;
  .nav-left {
    width: 19px;
    img {
      display: block;
      width: 9px;
    }
  }
  .nav-title {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    font-size: 17px;
    font-weight: 600;
    span {
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 250px;
    }
  }
  .nav-right {
    width: 19px;
    img {
      display: block;
      width: 19px;
    }
  }
}
.details {
  position: relative;
  flex: 1;
  padding: 0;
  overflow: auto;
  ::v-deep .mescroll {
    position: relative;
  }
  .albumInfoBg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 211px;
    // overflow: hidden;
    // background: url("https://Ethiconlive.tv-conf.com/Api/UploadImg/caf46ec6492c41fbacf073005d8b3dc9.png") center / cover no-repeat;
  }
  .albumInfoBg::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    background: linear-gradient(to bottom, rgba(249, 249, 249, 0.4) 0%, rgba(249, 249, 249, 1) 100%);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }
  .albumInfoBg::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    z-index: 9;
    height: 2px;
    background-color: rgba(249, 249, 249, 1);
  }
  .albumInfo {
    position: relative;
    z-index: 9;
    display: flex;
    flex-direction: column;
    align-items: center;
    .albumCover {
      display: block;
      width: 209px;
      border-radius: 13px;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
      margin: 16px auto;
      border: 0.5px solid #FFFFFF;
    }
    .albumTitle {
      font-size: 16px;
      font-weight: 500;
      color: #000000;
      line-height: 22px;
      margin: 0 34px;
      text-align: center;
    }
    .albumCount {
      display: flex;
      align-items: center;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      color: rgba(0, 0, 0, 0.6);
      margin-top: 4px;
      .dot {
        font-size: 14px;
      }
    }
  }
  .list {
    margin: 32px 16px 0;
    .listItem {
      display: flex;
      .listCover {
        position: relative;
        width: 128px;
        .cover {
          display: block;
          width: 100%;
          border-radius: 8px;
        }
        .cornerMark {
          position: absolute;
          top: 0;
          right: 8px;
          width: 25px;
        }
      }
      .listInfo {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 16px;
        .title {
          height: 32px;
          font-size: 12px;
          line-height: 16px;
          color: #000000;
        }
        .count {
          display: flex;
          align-items: center;
          font-size: 10px;
          color: rgba(0, 0, 0, 0.4);
          margin-top: 4px;
          .dot {
            font-size: 14px;
          }
        }
      }
      .listInfo::after {
        position: absolute;
        left: 0;
        bottom: -8px;
        content: '';
        width: 100%;
        height: 1px;
        background-color: rgba(0, 0, 0, 0.1);
      }
      @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 2dppx) {
        .listInfo::after { transform: scaleY(0.5); }
      }
      @media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 3dppx) {
        .listInfo::after { transform: scaleY(0.3333); }
      }
    }
    .listItem:not(:last-of-type) {
      margin-bottom: 16px;
    }
    .listItem1 {
      position: relative;
      display: flex;
      border-radius: 8px;
      background-color: #FFFFFF;
      .listCover {
        position: relative;
        width: 128px;
        .cover {
          display: block;
          width: 100%;
          border-radius: 8px;
        }
        .cornerMark {
          position: absolute;
          top: 0;
          right: 8px;
          width: 25px;
        }
      }
      .listInfo {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 12px;
        .title {
          height: 32px;
          font-size: 12px;
          line-height: 16px;
          color: #000000;
        }
        .topTitle {
          padding-right: 15px;
        }
        .count {
          display: flex;
          justify-content: flex-end;
          margin-top: 4px;
          .countItem {
            display: flex;
            align-items: center;
            margin-right: 10px;
          }
          .icon {
            display: block;
            width: 14px;
          }
          span {
            font-size: 10px;
            color: rgba(0, 0, 0, 0.8);
          }
        }
      }
      .top_icon {
        position: absolute;
        top: 0;
        right: 0;
        width: 28px;
      }
    }
    .listItem1:not(:last-of-type) {
      margin-bottom: 8px;
    }
  }
  .line {
    position: relative;
    padding-top: 8px;
  }
  .line::after {
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    width: 100%;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
  }
  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 2dppx) {
    .line::after { transform: scaleY(0.5); }
  }
  @media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 3dppx) {
    .line::after { transform: scaleY(0.3333); }
  }
}

.PosterPopup {
  width: 90%;
  height: 350px;
  border-radius: 14px;
  overflow-y: visible;
}
.close {
  position: absolute;
  top: -7px;
  right: -7px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 50%;
  background-image: linear-gradient(130deg, #EB1700 50%, #C33BBB 80%, #8C3BBB 100%);
  z-index: 99;
  .closeIcon {
    color: #FFFFFF;
  }
}
.PosterBox {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  border-radius: 14px;
  .generateImageBox {
    padding-bottom: 10px;
  }
  .PosterImg {
    display: block;
    width: 100%;
  }
  .QrcodeBox {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    .QrcodeFont {
      width: 60px;
    }
  }
  .Qrcode {
    display: block;
    width: 100px;
    margin: 0 30px ;
  }
  .PosterPhoto {
    display: block;
    width: 100%;
  }
  .tips {
    font-size: 13px;
    color: #333333;
    margin: 0 0 18px;
    text-align: center;
  }
}
</style>